/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-confusing-arrow */
/* eslint-disable import/no-cycle */
/* eslint-disable indent */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable quotes */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable spaced-comment */

export class XlsFileData {
    fromDate: Date;

    toDate: Date;

    data: any;

    constructor(fromDate: Date, toDate: Date, data: any) {
      this.fromDate = fromDate;
      this.toDate = toDate;
      this.data = data;
    }
}
